import { render, staticRenderFns } from "../views/editor.html?vue&type=template&id=9757a1d0&"
import script from "../scripts/editor.ts?vue&type=script&lang=ts&"
export * from "../scripts/editor.ts?vue&type=script&lang=ts&"
import style0 from "./editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ujjwal/projects/opensource/idbstudio/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9757a1d0', component.options)
    } else {
      api.reload('9757a1d0', component.options)
    }
    module.hot.accept("../views/editor.html?vue&type=template&id=9757a1d0&", function () {
      api.rerender('9757a1d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/editor.vue"
export default component.exports